import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";

@Pipe({
	name: "translate",
	pure: false,
	standalone: false
})
export class TranslationPipe implements PipeTransform {
	public constructor(private translationService: TranslationService) {}

	public transform(key: string, value: (number | string)[] = null, empty: boolean = false): string {
		if (!key || key.length === 0) {
			return "";
		}
		const trans = this.translationService.translate(key, value);
		return empty && trans === key ? "" : trans;
	}
}
